import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, Routes } from '@angular/router';
import { AuthSevices } from '@fitness-force/api';
import { LoginPayload } from '@fitness-force/models';
import { LoginProvider } from '@fitness-force/enum';
import { CommonModule } from '@angular/common';
import { environment } from 'apps/ff-frontend/src/environments/environment';

@Component({
  selector: 'app-auth-callback',
  template: '<div>Processing authentication...</div>',
  standalone: true,
  imports: [CommonModule,RouterModule]
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthSevices
  ) {}

  ngOnInit() {
    // Get the provider from the route
    const provider = this.route.snapshot.queryParamMap.get('provider');

    switch (provider) {
      case 'apple':
        this.handleAppleCallback();
        break;
      case 'microsoft':
        this.handleMicrosoftCallback();
        break;
      default:
        this.router.navigate(['/auth/login']);
    }
  }

  private handleAppleCallback() {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');

    if (code && state) {
      try {
        const stateData = JSON.parse(state);
        const payload: LoginPayload = {
          provider: LoginProvider.Apple,
          idToken: code,
          company_uuid: stateData.company_uuid,
        };

        this.authService.socialLogin(payload).subscribe({
          next: (response) => {
            if (stateData.callbackUrl) {
              window.location.href = `${
                stateData.callbackUrl
              }?returnUrl=${encodeURIComponent(
                stateData.returnUrl
              )}&companyUuid=${stateData.company_uuid}&token=${
                response.token
              }&callback=true`;
            } else {
              this.router.navigate(['/']);
            }
          },
          error: (error) => {
            console.error('Apple auth error:', error);
            this.router.navigate(['/auth/login']);
          },
        });
      } catch (error) {
        this.router.navigate(['/auth/login']);
      }
    }
  }

  private handleMicrosoftCallback() {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const error = this.route.snapshot.queryParamMap.get('error');

    if (error) {
      this.router.navigate(['/auth/login']);
      return;
    }

    if (code && state) {
      try {
        const stateData = JSON.parse(state);

        // Create MSAL instance to handle token acquisition
        const msalConfig = {
          auth: {
            clientId: environment.MICROSOFT_CLIENT_ID,
            authority:
              'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
            redirectUri: environment.CALLBACK_URL,
          },
          cache: {
            cacheLocation: 'sessionStorage',
          },
        };

        // @ts-expect-error
        const msalInstance = new msal.PublicClientApplication(msalConfig);

        // Handle the redirect response
        msalInstance
          .handleRedirectPromise()
          .then((response: any) => {
            if (response) {
              const payload: LoginPayload = {
                provider: LoginProvider.Microsoft,
                idToken: response.accessToken,
                company_uuid: stateData.company_uuid,
              };

              this.authService.socialLogin(payload).subscribe({
                next: (response) => {
                  if (stateData.callbackUrl) {
                    window.location.href = `${
                      stateData.callbackUrl
                    }?returnUrl=${encodeURIComponent(
                      stateData.returnUrl
                    )}&companyUuid=${stateData.company_uuid}&token=${
                      response.token
                    }&callback=true`;
                  } else {
                    this.router.navigate(['/']);
                  }
                },
                error: (error) => {
                  console.error('Microsoft auth error:', error);
                  this.router.navigate(['/auth/login']);
                },
              });
            }
          })
          .catch((error: any) => {
            console.error('Error handling redirect:', error);
            this.router.navigate(['/auth/login']);
          });
      } catch (error) {
        console.error('Error parsing state:', error);
        this.router.navigate(['/auth/login']);
      }
    }
  }
}

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AuthCallbackComponent,
  }
];